// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3W9sV","header":"MessagesList_header__2Rrc9","chat":"MessagesList_chat__13RFU"};